module.exports = __webpack_public_path__ + "img/garage.1f5aacaa.svg";